import styled from 'styled-components'

import { ReactComponent as CorrectIcon } from '../../../assets/illustrations/correct-circle.svg'
import { ReactComponent as ErrorIcon } from '../../../assets/illustrations/error-circle.svg'

export const CorrectCircle = styled(CorrectIcon)``

export const ErrortCircle = styled(ErrorIcon)``
